import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import flexCheck from '../../../../utils/flexCheck';

const ScrollViews = React.forwardRef((props, ref) => {
  const styles = StyleSheet.flatten(props.style);
  let updatedStyles = false;
  if (typeof props !== 'undefined' && typeof styles !== 'undefined') {
    updatedStyles = flexCheck(styles);
  }
  return (
    <>
      <ScrollView
        ref={ref}
        {...props}
        style={updatedStyles ? updatedStyles : styles}
      />
    </>
  );
});
export default ScrollViews;
